import { StoreAction } from '@shared/store/store-action.model';

export namespace AppActions {

  export class SetToken extends StoreAction<string> {
    static override readonly type = '[App] Set Token';

    constructor(public override payload: string) {
      super(payload);
    }
  }

  export class ClearSession extends StoreAction<void> {
    static override readonly type = '[App] Clear Session';
  }

  export class SetLocale extends StoreAction<string> {
    static override readonly type = '[App] Set Locale';

    constructor(public override payload: string) {
      super(payload);
    }
  }

  export class SetOnboardingCompleted extends StoreAction<boolean> {
    static override readonly type = '[App] Set Onboarding Completed';

    constructor(public override payload: boolean) {
      super(payload);
    }
  }
}
